import { Button } from "@devhop/ui";
import { usePermissions } from "@/modules/auth/presentation/model/usePermissions";
import {
  useEndLive,
  useLiveDetailQuery,
  useSyncLiveStatus,
} from "../api/queries";
import { workspaceErrorMessage } from "../api/workspace-client";

export function LiveBroadcastControls({ feedId }: { feedId: string }) {
  const detail = useLiveDetailQuery(feedId);
  const sync = useSyncLiveStatus(feedId);
  const end = useEndLive(feedId);
  const { has } = usePermissions();
  const error = detail.error ?? sync.error ?? end.error;
  return (
    <section className="space-y-3 rounded-lg border p-4">
      <h2 className="font-semibold">Facebook Live</h2>
      {detail.data && (
        <p className="text-sm">
          {detail.data.displayStatus} · ຜູ້ຊົມ {detail.data.liveViews ?? "—"}
        </p>
      )}
      {error && (
        <p role="alert" className="text-destructive">
          {workspaceErrorMessage(error)}
        </p>
      )}
      <div className="flex flex-wrap gap-2">
        <Button
          variant="outline"
          className="min-h-11"
          disabled={!has("live:manage") || sync.isPending}
          onClick={() => sync.mutate()}
        >
          ອັບເດດສະຖານະ
        </Button>
        {detail.data?.feed.permalinkUrl && (
          <a
            href={detail.data.feed.permalinkUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-11 items-center underline"
          >
            ເປີດ Facebook
          </a>
        )}
        <Button
          variant="destructive"
          className="min-h-11"
          disabled={!has("live:manage") || end.isPending}
          onClick={() => {
            if (window.confirm("ຢືນຢັນຈົບ Facebook Live?")) end.mutate();
          }}
        >
          ຈົບ Facebook Live
        </Button>
      </div>
      <p className="text-muted-foreground text-sm">
        ປຸ່ມປິດຮັບ CF ຢຸດຮັບອໍເດີ. ປຸ່ມຈົບ Facebook Live ຢຸດການຖ່າຍທອດ.
      </p>
    </section>
  );
}
